/*
This file contains functions that can be used to embed delivery tabs on product page

*/
var delivery_tabs = {
    courierData: [],
    init() {
        this.loadFile(delivery_file);
    },
    loadFile(file) {
        $.ajax({
            type: "GET",
            url: file,
            dataType: "text",
            success: function(data) { delivery_tabs.processData(data); }
        });
    },
    CSVToArray(strData, strDelimiter) {
        // Check to see if the delimiter is defined. If not,
        // then default to comma.
        strDelimiter = (strDelimiter || ",");

        // Create a regular expression to parse the CSV values.
        var objPattern = new RegExp(
            (
                // Delimiters.
                "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

                // Quoted fields.
                "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

                // Standard fields.
                "([^\"\\" + strDelimiter + "\\r\\n]*))"
            ),
            "gi"
        );


        // Create an array to hold our data. Give the array
        // a default empty first row.
        var arrData = [
            []
        ];

        // Create an array to hold our individual pattern
        // matching groups.
        var arrMatches = null;


        // Keep looping over the regular expression matches
        // until we can no longer find a match.
        while (arrMatches = objPattern.exec(strData)) {

            // Get the delimiter that was found.
            var strMatchedDelimiter = arrMatches[1];

            // Check to see if the given delimiter has a length
            // (is not the start of string) and if it matches
            // field delimiter. If id does not, then we know
            // that this delimiter is a row delimiter.
            if (
                strMatchedDelimiter.length &&
                strMatchedDelimiter !== strDelimiter
            ) {

                // Since we have reached a new row of data,
                // add an empty row to our data array.
                arrData.push([]);

            }

            var strMatchedValue;

            // Now that we have our delimiter out of the way,
            // let's check to see which kind of value we
            // captured (quoted or unquoted).
            if (arrMatches[2]) {

                // We found a quoted value. When we capture
                // this value, unescape any double quotes.
                strMatchedValue = arrMatches[2].replace(
                    new RegExp("\"\"", "g"),
                    "\""
                );

            } else {

                // We found a non-quoted value.
                strMatchedValue = arrMatches[3];

            }


            // Now that we have our value string, let's add
            // it to the data array.
            arrData[arrData.length - 1].push(strMatchedValue);
        }

        // Return the parsed data.
        return (arrData);
    },
    processData(allText) {
        let allTextLines = this.CSVToArray(allText);

        let courierData = null;
        for (const line of allTextLines) {
           if (line.includes('Couriers')) {
              courierData =  {
                courierTags: line.slice(1),
                deliveryTableRows: [],
                info: []
              };

              this.courierData.push(courierData);
            } else {
              if (courierData != null) {
              	courierData.deliveryTableRows.push(line);
              }
            }
        }

		let productCourier = window?.product_tags?.split(',').find(element => element.startsWith("meta-courier:"));

      	let table = '<table>';

        if (productCourier !== undefined) {
		  let thisCourierData = this.courierData.find(e => e.courierTags.includes(productCourier));

          if (thisCourierData !== undefined) {
            let isHeader = true;

            for(const row of thisCourierData.deliveryTableRows) {
              if (isHeader === true) {
                table += '<tr><th class="locationName">' + row[0] + '</th><th class="locationDelPrice">' + row[1] + '</th></tr>';
                isHeader = false;
              } else {
                let column_1 = row[0].split('['), price = row[1];

                let build_column = column_1[0];

                if (column_1.length > 1) {
                  build_column += '<small>' + column_1[1].replace(']', '') + '</small>';
                }

                table += '<tr><td>' + build_column + '</td><td class="price_data_col">' + price + '</td></tr>';
              }
            }
          }
        }

      	table += '</table>';

        // render table
        $('.delivery-part-1').html(table);
    }
}

function readyCustom(callback) {
    if (document.readyState != 'loading') callback();
    else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
}
readyCustom(function() { delivery_tabs.init(); })